module.exports = __webpack_public_path__ + "success_icon.4bc99f37.svg";